// src/features/procedures/components/ProcedureStepCard.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Paper,
  Typography,
  Chip,
} from '@mui/material';
import {
  RadioButtonUnchecked as OptionalIcon,
  TextFields as TextIcon,
} from '@mui/icons-material';

// Import step type config
import { getStepTypeConfig } from '../config/stepTypes';
import StepDescription from './StepDescription';

export default function ProcedureStepCard({ step, stepNumber }) {
  const { t } = useTranslation(['procedures']);

  const stepConfig = getStepTypeConfig(step.step_type) || {
    icon: TextIcon,
    label: step.step_type,
    color: 'default',
    component: null,
  };

  const StepIcon = stepConfig.icon;
  const StepComponent = stepConfig.component;

  return (
    <Paper variant="outlined" sx={{ p: 2.5 }}>
      <Box display="flex" gap={2} mb={2}>
        <Box
          sx={{
            minWidth: 32,
            height: 32,
            borderRadius: '50%',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            flexShrink: 0,
          }}
        >
          {stepNumber}
        </Box>

        <Box flex={1} minWidth={0}>
          <Box display="flex" gap={1} alignItems="center" mb={0.5} sx={{ flexWrap: 'wrap' }}>
            <Typography variant="subtitle1" fontWeight={600}>
              {step.label}
              {step.is_required && (
                <Typography component="span" color="error.main" sx={{ ml: 0.5 }}>
                  *
                </Typography>
              )}
            </Typography>
            <Box flex={1} />
            <Chip
              icon={<StepIcon />}
              label={t(`procedures:step_types.${step.step_type}`, stepConfig.label)}
              size="small"
              color={stepConfig.color}
              variant="outlined"
            />
            {!step.is_required && (
              <Chip
                icon={<OptionalIcon />}
                label={t('procedures:labels.optional')}
                size="small"
                variant="outlined"
              />
            )}
          </Box>

          {step.description && <StepDescription description={step.description} />}

          {StepComponent && (
            <Box sx={{ mt: 2 }}>
              <StepComponent
                step={step}
                value={null}
                onChange={() => {}}
                disabled={true}
                preview={true}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
}